import { useEffect, useState } from "react";
import { api } from "../api/axios";
import { useI18n } from "../../i18n/I18nContext";

export default function UserAddresses() {
  const { t } = useI18n();
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openForm, setOpenForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const [form, setForm] = useState({
    label: "",
    recipient_name: "",
    line1: "",
    line2: "",
    city: "",
    postal_code: "",
    country_code: "PT",
    phone: "",
  });

  const loadAddresses = async () => {
    try {
      setLoading(true);
      const res = await api.get("/api/v1/addresses");
      setAddresses(res.data.data || []);
    } catch (e) {
      console.error("Erro ao carregar moradas", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAddresses();
  }, []);

  const openCreate = () => {
    setEditing(null);
    setForm({
      label: "",
      recipient_name: "",
      line1: "",
      line2: "",
      city: "",
      postal_code: "",
      country_code: "PT",
      phone: "",
    });
    setOpenForm(true);
  };

  const openEdit = (addr) => {
    setEditing(addr);
    setForm(addr);
    setOpenForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editing) {
        await api.put(`/api/v1/addresses/${editing.id}`, form);
      } else {
        await api.post("/api/v1/addresses", form);
      }

      setOpenForm(false);
      loadAddresses();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(t("Apagar esta morada?"))) return;

    await api.delete(`/api/v1/addresses/${id}`);
    loadAddresses();
  };

  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">{t("Moradas")}</h2>
        <button
          onClick={openCreate}
          className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm"
        >
          {t("+ Nova morada")}
        </button>
      </div>

      {loading ? (
        <p className="text-gray-500">{t("A carregar...")}</p>
      ) : addresses.length === 0 ? (
        <p className="text-gray-500">{t("Sem moradas guardadas.")}</p>
      ) : (
        <div className="grid gap-4">
          {addresses.map((a) => (
            <div
              key={a.id}
              className="border rounded-xl p-4 flex justify-between items-start"
            >
              <div>
                <p className="font-semibold">{a.label || t("Morada")}</p>
                <p className="text-sm">{a.recipient_name}</p>
                <p className="text-sm">{a.line1}</p>
                <p className="text-sm">
                  {a.postal_code} {a.city}
                </p>
                <p className="text-sm">{a.country_code}</p>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => openEdit(a)}
                  className="text-sm text-gray-600 hover:text-black"
                >
                  {t("Editar")}
                </button>
                <button
                  onClick={() => handleDelete(a.id)}
                  className="text-sm text-red-500"
                >
                  {t("Apagar")}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {openForm && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center">
          <form
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl p-6 w-full max-w-lg space-y-4"
          >
            <h3 className="text-lg font-semibold">
              {editing ? t("Editar morada") : t("Nova morada")}
            </h3>

            <input
              placeholder={t("Etiqueta (Casa, Trabalho...)")}
              value={form.label}
              onChange={(e) =>
                setForm({ ...form, label: e.target.value })
              }
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Nome do destinatário")}
              value={form.recipient_name}
              onChange={(e) =>
                setForm({ ...form, recipient_name: e.target.value })
              }
              required
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Morada")}
              value={form.line1}
              onChange={(e) =>
                setForm({ ...form, line1: e.target.value })
              }
              required
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Complemento")}
              value={form.line2}
              onChange={(e) =>
                setForm({ ...form, line2: e.target.value })
              }
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Cidade")}
              value={form.city}
              onChange={(e) =>
                setForm({ ...form, city: e.target.value })
              }
              required
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Código Postal")}
              value={form.postal_code}
              onChange={(e) =>
                setForm({ ...form, postal_code: e.target.value })
              }
              required
              className="w-full border px-3 py-2 rounded"
            />

            <input
              placeholder={t("Telefone")}
              value={form.phone}
              onChange={(e) =>
                setForm({ ...form, phone: e.target.value })
              }
              className="w-full border px-3 py-2 rounded"
            />

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setOpenForm(false)}
                className="px-4 py-2"
              >
                {t("Cancelar")}
              </button>

              <button className="bg-gray-900 text-white px-4 py-2 rounded">
                {t("Guardar")}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}